import { ojs, app, each, v } from "modular-openscriptjs";
import { either } from "../helpers";
import Navigation from "./Navigation";
import { dom } from "../fotastart";
import { NavItem } from "../declarations";
import { gc, pc } from "../declarations";
import { $e } from "../ojs.events";

const h = app("h");

export default class OffCanvasNav extends Navigation {
	name = "OffCanvasNav";

	$$ui = {
		needs: {
			offcanvas: {
				nav: () => {
					dom.id("cmp-show-offcanvas-nav")?.click();
				},
			},
		},
	};

	$$ojs = {
		routeChanged: () => {
			if (!dom.get("#offcanvasNav.show")) return;

			let canvas = bootstrap.Offcanvas.getInstance(
				dom.id("offcanvasNav")
			);

			canvas.hide();
		},
	};

	render(...args) {
		return h.div(
			{
				class: "offcanvas offcanvas-end",
				tabindex: "-1",
				id: "offcanvasNav",
				aria_labelledby: "offcanvasNavLabel",
				style: `
                    min-height: 200px;
                    height: max-content;
                    max-height: 500px;
                    width: 276px;
                    border-radius: 1rem;
                    top: auto;
                    bottom: 70px;
                    right: 1rem;
                `,
				data_bs_scroll: "true",
				data_bs_backdrop: "false",
			},

			h.div(
				{ class: "offcanvas-header" },
				h.h4(
					{
						class: "offcanvas-title fw-400",
						id: "offcanvasNavLabel",
					},
					"More"
				),
				h.button({
					id: "cmp-show-offcanvas-nav",
					style: "visibility:hidden;",
					class: "d-none",
					data_bs_toggle: "offcanvas",
					data_bs_target: "#offcanvasNav",
				}),
				h.button({
					type: "button",
					class: "btn-close text-reset",
					data_bs_dismiss: "offcanvas",
					aria_label: "Close",
				})
			),

			h.div(
				{ class: "offcanvas-body pt-0" },

				h.ul(
					{ class: "list-reset ms-reset py-3 border-top" },
					h.ul(
						{ class: "list-unstyled" },

						v(pc.offCanvasItems, (items) => {
							return this.renderNav(items.value);
						}),
					)
				)
			),

			h.div(
				{ class: "border-top border-2 p-3" },
				h.div(
					{ class: "" },
					h.h5(
						{
							class: "offcanvas-title fw-300",
							id: "offcanvasNavLabel",
							data_bs_dismiss: "offcanvas",
							aria_label: "Close",
						},
						h.span(h.i({ class: "bi bi-x-circle" })),
						" Close"
					)
				)
			),

			...args
		);
	}

	/**
	 * Parse a nav item
	 * @param {NavItem} item
	 */
	parseItem(item, ...args) {
		if (!item.condition()) return null;

		return h.li(
			{
                app_hook: "app-nav",
                app_nav_hook: item.appHook,
                onclick: item.onclick,
            },
			h.a(
				{
					class: "dropdown-item d-flex gap-2 align-items-center",
					onclick: item.onclick,
				},
				h.span({ class: "icon" }, item.icon()),
				h.span({ class: "text" }, item.text),
				either(item.children.length > 0, {
					class: "dropdown-toggle align-items-center",
					role: "button",
					data_bs_toggle: "dropdown",
					aria_expanded: "false",
				})
			),
			either(
				item.children.length > 0 && this.dropdownDir() !== "dropdown",
				{ class: this.dropdownDir() }
			),
			this.dropdown(item.children),
			...args
		);
	}
}

ojs(OffCanvasNav);
